import React from 'react';
import { styled } from '@withjoy/joykit';

const WorkspaceGridItemWrapper = styled.div<{ highlightColor: string; shadedColor: string; shadowColor: string; expanded?: boolean; allowScroll?: boolean }>`
  position: ${props => (props.expanded ? 'absolute' : 'relative')};
  ${props => {
    if (props.expanded) {
      return `

        z-index: 9000;
        width: calc(100% - 32px);
        height: calc(100% - 32px);;
  min-width: 240px;
  max-width: 1000px;
  max-height: 1000px;
  min-height: 280px;
  margin: 16px;
      `;
    } else {
      return `
        top: 0;
        left: 0;
        z-index: 1000;
        width: 100%;
  min-width: 240px;
  height: 400px;
   margin: auto;
 
      `;
    }
  }}

  border-radius: 24px;

  background: ${props => `linear-gradient(180deg, ${props.highlightColor} 0%, ${props.shadedColor} 100%)`};
  box-shadow: 0px 1px 3px ${props => props.shadowColor};
  user-select: none;
  padding: 0;
  overflow: ${props => (props.allowScroll ? 'scroll' : 'hidden')};

  ${props => {
    if (!props.expanded) {
      return `
        &:hover,
  &:focus {
    transform: scale(1.01);
    box-shadow: 0px 1px 9px ${props.shadowColor};
  }
      `;
    }
    return;
  }}
`;

interface WorkspaceGridItemProps {
  highlightColor: string;
  shadedColor: string;
  shadowColor: string;
  id: string;
  allowScroll?: boolean;

  children: React.ReactNode;
  handleDragStart: (event: React.DragEvent<HTMLDivElement>) => void;
  handleDrop: (event: React.DragEvent<HTMLDivElement>) => void;
  handleDragOver: (event: React.DragEvent<HTMLDivElement>) => void;
  handleDragLeave: (event: React.DragEvent<HTMLDivElement>) => void;
}

export const WorkspaceGridItem: React.FC<WorkspaceGridItemProps> = ({
  highlightColor,
  shadedColor,
  shadowColor,
  children,
  id,
  handleDragLeave,
  handleDragStart,
  handleDragOver,
  handleDrop,
  allowScroll,
}) => {
  const [expanded, setExpanded] = React.useState(false);
  const toggleExpansion = () => {
    setExpanded(!expanded);
  };
  return (
    <WorkspaceGridItemWrapper
      draggable
      onDragStart={handleDragStart}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onClick={toggleExpansion}
      expanded={expanded}
      key={id}
      highlightColor={highlightColor}
      shadedColor={shadedColor}
      shadowColor={shadowColor}
      allowScroll={allowScroll}
    >
      <div style={{ width: '100%', height: '100%' }}> {children}</div>
    </WorkspaceGridItemWrapper>
  );
};

//{ gridColumnStart: 1, gridColumnEnd: width > 900 ? 3 : 2 }
